import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function WrongBrowserDialog({ url }: { url: string }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 dark:bg-background/95">
      <div className="w-full max-w-md rounded-lg border border-border bg-card shadow-lg p-8 flex flex-col items-center">
        <h2 className="text-2xl font-bold mb-4 text-foreground">Unsupported Browser</h2>
        <p className="mb-4 text-center text-base text-muted-foreground">
          This app cannot be used inside an embedded webview.<br />
          Please copy the link below and open it in your mobile browser (Chrome or Safari).
        </p>
        <Input
          value={url}
          readOnly
          className="mb-4 text-center text-base max-w-xs cursor-pointer select-all"
          onFocus={e => e.target.select()}
        />
        <Button
          className="w-full max-w-xs"
          onClick={() => {
            navigator.clipboard.writeText(url);
          }}
        >
          Copy Link
        </Button>
      </div>
    </div>
  );
}
